import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { Category } from '../../model/category';
import { WebsiteService } from '../../service/website.service';

/**
 * The `categories` partial: three columns of category tiles. The Mustache version indexed the
 * list by hand (0,3,6 / 1,4,7 / 2,5,8); here the same layout falls out of a modulo.
 */
@Component({
  selector: 'categories',
  imports: [RouterLink],
  host: {
    style: 'display: contents'
  },
  template: `
    <!-- Banner -->
    <section class="banner bgwhite p-t-40 p-b-40">
      <div class="container">
        <div class="row">
          @for (column of columns; track column) {
            <div class="col-sm-10 col-md-8 col-lg-4 m-l-r-auto">
              @for (category of categoriesOf(column); track $index) {
                <div class="block1 hov-img-zoom pos-relative m-b-30">
                  <a [routerLink]="'/' + category.code">
                    <img class="lazyload" [src]="category.photo" [alt]="category.name">
                  </a>

                  <div class="block1-wrapbtn w-size2">
                    <!-- Button -->
                    <a class="flex-c-m size2 m-text2 bg3 hov1 trans-0-4" [routerLink]="'/' + category.code">
                      {{category.name}}
                    </a>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </section>
    `
})
export class CategoriesComponent {

  readonly columns = [0, 1, 2];

  private websites = inject(WebsiteService);

  private categories = computed(() => (this.websites.current().categories ?? [])
    .filter(category => category.photo));

  categoriesOf(column: number): Category[] {
    return this.categories().filter((category, index) => index % 3 === column);
  }

}
